import React from 'react';
import {
  Tile,
  TileContent,
  TileGroup,
  TileStateIndicator,
} from '@one-thd/sui-atomic-components';
import { ItemToReturn } from '@src/models/returns';
import { setSelectedItems, useReturnStore } from '@src/stores/returnStore';
import ItemImage from '@src/components/shared/items/ItemImage';
import ItemDescription from '@src/components/shared/items/ItemDescription';
import ItemQuantityCostRow from '../shared/items/ItemQuantityCostRow';

interface SelectItemProps {
  item: ItemToReturn;
}

const SelectItem = ({ item }: SelectItemProps) => {
  const selectedItems = useReturnStore((state) => state.selectedItems);
  const isSelected = selectedItems.some(
    (i) => i.lineItemId === item.lineItemId,
  );

  // TileGroup needs array of selected IDs
  const selectedValue = isSelected ? [item.lineItemId] : [];

  const handleItemChange = (
    event: React.SyntheticEvent,
    newSelectedIds: string[],
  ) => {
    const isNowSelected = newSelectedIds.includes(item.lineItemId);

    if (isNowSelected && !isSelected) {
      setSelectedItems([...selectedItems, item]);
    } else if (!isNowSelected && isSelected) {
      setSelectedItems(
        selectedItems.filter((i) => i.lineItemId !== item.lineItemId),
      );
    }
  };

  return (
    <div className="sui-flex sui-w-full sui-gap-4">
      <TileGroup
        grow
        value={selectedValue}
        onChange={handleItemChange}
        disableExclusive
      >
        <Tile value={item.lineItemId}>
          <TileContent>
            <div className="sui-flex sui-h-full sui-w-full sui-pt-1 sui-px-1 sui-items-center sui-gap-2">
              <TileStateIndicator />
              <ItemImage
                itemDescription={item?.itemDescription}
                imageUrl={item?.itemImageURL}
                marginY
              />
              <div className="sui-flex-col sui-ml-2">
                <ItemDescription
                  brandName={item?.brandName}
                  itemDescription={item?.itemDescription}
                  fullWidth
                  noMargin
                />
                <ItemQuantityCostRow
                  quantity={item?.currentQuantity}
                  cost={item?.itemCost}
                />
              </div>
            </div>
          </TileContent>
        </Tile>
      </TileGroup>
    </div>
  );
};

export default SelectItem;
